import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { Service } from './service';

export default class DeliveryTimeService extends Service{

  async get(lat: number, lng: number, timestamp: number, isEcommerce: boolean) {
    let type = '';

    if (isEcommerce) {
      type = 'ecommerce';
    }

    return await doRequest({
      auth: false,
      url: `${this.root}v2/delivery-time`,
      method: HttpMethodEnum.GET,
      params: { lat, lng, timestamp, type },
    });
  }
}
